// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2Fyy4","calendarButtons":"ClockData_calendarButtons__1Apt5"};